import { render } from "./MaterialInventory.vue?vue&type=template&id=149d765d"
import script from "./MaterialInventory.vue?vue&type=script&lang=js"
export * from "./MaterialInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__